import { sample } from 'effector';
import { $ticketData } from '../ticket/ticket.model';
import {
  fxGetAvailableTehzor,
  fxSendTicketToTehzor,
  $isAvailableTehzor, 
  $isSendedToTehzor,
  sendTicketToTehzor
} from './ticket-tehzor.model';

$isAvailableTehzor.on(fxGetAvailableTehzor.done, (_, { result }) => result.is_enabled);
$isSendedToTehzor
  .on(fxGetAvailableTehzor.done, (_, { result }) => result.is_sent)
  .on(fxSendTicketToTehzor.done, (_, { result }) => result.success);

sample({
  clock: sendTicketToTehzor,
  source: $ticketData,
  fn: ({ id }) => id as number,
  target: fxSendTicketToTehzor,
});